"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VTagInputField = void 0;
var mobx_react_1 = require("mobx-react");
var React = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
var ToastNotification_1 = require("../../ToastNotification");
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var VTagInputField = (function (_super) {
    __extends(VTagInputField, _super);
    function VTagInputField(props) {
        var _this = _super.call(this, props) || this;
        _this.innerSeparator = /[,\n\r\s]/;
        _this.setRef = function (ref) {
            _this.inputRef = ref;
        };
        _this.setInputValue = function (value) {
            _this.inputValue = value;
        };
        _this.setOnPasteCapture = function (value) {
            _this.onPasteCapture = value;
        };
        _this.handleOnPasteCapture = function () {
            _this.setOnPasteCapture(true);
        };
        _this.updateField = function (value) {
            if (_this.innerSeparator.test(value)) {
                var splitedValues = "".concat(value)
                    .split(_this.innerSeparator)
                    .filter(function (el) { return !!el; });
                _this.handleChange(__spreadArray(__spreadArray([], (_this.valueField || []), true), (splitedValues || []), true));
            }
            else {
                _this.setInputValue(value);
            }
        };
        _this.onInputChange = function (e) {
            var _a;
            var value = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            _this.updateField(value);
            if (_this.onPasteCapture) {
                _this.inputRef.blur();
                setTimeout(function () {
                    _this.setOnPasteCapture(false);
                    _this.inputRef.focus();
                });
            }
        };
        _this.avoidInsertSeparatorOnly = function (event) {
            if ([188, 32].includes(event === null || event === void 0 ? void 0 : event.which) && !_this.inputValue) {
                event.preventDefault();
            }
        };
        _this.handleChange = function (values) {
            _this.setInputValue('');
            _this.setOnPasteCapture(false);
            var newValues = values;
            if (_this.props.limit &&
                newValues &&
                newValues.length > 0 &&
                newValues.length > _this.props.limit) {
                newValues = newValues.filter(function (item, index) { return _this.props.limit && index < _this.props.limit; });
            }
            if (_this.props.tagValidation && _this.props.tagValidation.regex) {
                newValues = newValues.filter(function (item) {
                    var result = _this.props.tagValidation &&
                        _this.props.tagValidation.regex.test((item && item.toString()) || '');
                    if (!result) {
                        (0, ToastNotification_1.showToastNotification)({
                            message: "".concat((item && item.toString()) || '', " ").concat((_this.props
                                .tagValidation &&
                                _this.props.tagValidation.errorMessage) ||
                                'is not valid'),
                            type: 'danger'
                        });
                    }
                    return result;
                });
            }
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange(newValues);
            }
            if (_this.props.onChange) {
                _this.props.onChange(newValues);
            }
        };
        _this.handleClear = function () { return _this.handleChange([]); };
        _this.inputValue = '';
        return _this;
    }
    VTagInputField.prototype.render = function () {
        var _a = this.props, label = _a.label, labelInfo = _a.labelInfo, fieldState = _a.fieldState, leftIcon = _a.leftIcon, fill = _a.fill, size = _a.size, disabled = _a.disabled, inline = _a.inline, placeholder = _a.placeholder, id = _a.id, tagProps = _a.tagProps, className = _a.className, layer = _a.layer, noLabel = _a.noLabel, required = _a.required, validators = _a.validators, value = _a.value, separator = _a.separator, tooltip = _a.tooltip, displayRequired = _a.displayRequired, margin = _a.margin, onBlur = _a.onBlur, onFocus = _a.onFocus;
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
        var clearButton = (!!fieldState && fieldState.$ && fieldState.$.length > 0) ||
            (!!value && value.length > 0) ? (React.createElement(core_1.Button, { disabled: disabled, icon: 'cross', minimal: true, onClick: this.handleClear })) : (undefined);
        return (React.createElement(style_1.StyledTagsInput, { className: className, disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, margin: margin },
            React.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
                React.createElement(core_1.TagInput, __assign({ separator: separator || this.innerSeparator }, {
                    leftIcon: leftIcon,
                    disabled: disabled,
                    placeholder: placeholder,
                    id: id,
                    fill: fill
                }, { rightElement: clearButton, tagProps: tagProps, large: size === 'large', onChange: this.handleChange, values: this.valueField, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, onKeyDown: this.avoidInsertSeparatorOnly, inputRef: this.setRef, addOnBlur: true, inputValue: this.inputValue, inputProps: {
                        onBlur: onBlur,
                        onFocus: onFocus,
                        onPasteCapture: this.handleOnPasteCapture,
                        itemRef: this.inputRef
                    }, onInputChange: this.onInputChange })))));
    };
    Object.defineProperty(VTagInputField.prototype, "valueField", {
        get: function () {
            if (this.props.fieldState && (0, lodash_1.isArray)(this.props.fieldState.value)) {
                return this.props.fieldState.value;
            }
            if (this.props.value && (0, lodash_1.isArray)(this.props.value)) {
                return this.props.value;
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], VTagInputField.prototype, "inputValue", void 0);
    __decorate([
        mobx_1.observable
    ], VTagInputField.prototype, "onPasteCapture", void 0);
    __decorate([
        mobx_1.action
    ], VTagInputField.prototype, "setInputValue", void 0);
    __decorate([
        mobx_1.action
    ], VTagInputField.prototype, "setOnPasteCapture", void 0);
    __decorate([
        mobx_1.action
    ], VTagInputField.prototype, "handleOnPasteCapture", void 0);
    __decorate([
        mobx_1.action
    ], VTagInputField.prototype, "updateField", void 0);
    __decorate([
        mobx_1.action
    ], VTagInputField.prototype, "onInputChange", void 0);
    __decorate([
        mobx_1.computed
    ], VTagInputField.prototype, "valueField", null);
    VTagInputField = __decorate([
        mobx_react_1.observer
    ], VTagInputField);
    return VTagInputField;
}(React.Component));
exports.VTagInputField = VTagInputField;
